import styled, { createGlobalStyle, css } from "styled-components";
import { normalize } from "styled-normalize";
import { colors, interaction } from "../../theme";
import "./layout.css";

export const interactionClassNames = {
  link: "pw-link",
  linkMuted: "pw-link pw-link--muted",
  textAction: "pw-text-action",
};

export const getLinkClassName = (tone = "default") => {
  if (tone === "muted") {
    return interactionClassNames.linkMuted;
  }
  return interactionClassNames.link;
};

const Flex = styled.div`
  position: relative;
  display: flex;
  align-items: center;

  ${props =>
    props.row &&
    css`
      flex-direction: row;
    `}

  ${props =>
    props.column &&
    css`
      flex-direction: column;
    `}

  ${props =>
    props.spaceBetween &&
    css`
      justify-content: space-between;
    `}

  ${props =>
    props.flexEnd &&
    css`
      justify-content: flex-end;
    `}

  ${props =>
    props.alignTop &&
    css`
      justify-content: flex-start;
    `}

    ${props =>
    props.alignCenter &&
    css`
      justify-content: center;
    `}


  ${props =>
    props.alignLeft &&
    css`
      align-items: flex-start;
    `}

  ${props =>
    props.noHeight &&
    css`
      height: 0;
    `}
`;

const GlobalStyle = createGlobalStyle`
  ${normalize};

  .pw-link {
    cursor: pointer;
    transition: ${interaction.transition};
    text-decoration: ${interaction.link.default.textDecoration};
    color: ${interaction.link.default.color};

    &:hover:not(:disabled),
    &:focus-visible:not(:disabled) {
      color: ${interaction.link.hover.color};
      text-decoration: ${interaction.link.hover.textDecoration};
    }

    &:focus-visible {
      outline: 2px solid ${colors.linkHover.light};
      outline-offset: 2px;
    }
  }

  .pw-link--muted {
    color: ${interaction.link.muted.default.color};

    &:hover:not(:disabled),
    &:focus-visible:not(:disabled) {
      color: ${interaction.link.muted.hover.color};
      text-decoration: ${interaction.link.muted.hover.textDecoration};
    }

    &:focus-visible {
      outline-color: ${colors.linkHover.dark};
    }
  }

  .pw-text-action {
    cursor: pointer;
    transition: ${interaction.transition};
    text-decoration: none;
    color: ${interaction.textAction.default.color};

    &:hover:not(:disabled),
    &:focus-visible:not(:disabled) {
      color: ${interaction.textAction.hover.color};
      text-decoration: ${interaction.textAction.hover.textDecoration};
    }
  }
`;
export { Flex };
export default GlobalStyle;
